import React from "react";

export default function MerchantIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        width: "20px",
        height: "20px",
      }}
      fill="#37b9b9"
      viewBox="0 0 256 256"
    >
      <rect width="256" height="256" fill="none"></rect>
      <rect
        x="40"
        y="40"
        width="176"
        height="176"
        rx="8"
        fill="none"
        stroke="#37b9b9"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></rect>
      <line
        x1="100"
        y1="216"
        x2="100"
        y2="144"
        fill="none"
        stroke="#37b9b9"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></line>
      <line
        x1="156"
        y1="216"
        x2="156"
        y2="144"
        fill="none"
        stroke="#37b9b9"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></line>
      <polyline
        points="176 40 176 144 128 144 128 40"
        fill="none"
        stroke="#37b9b9"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></polyline>
      <polyline
        points="128 40 128 144 80 144 80 40"
        fill="none"
        stroke="#37b9b9"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      ></polyline>
    </svg>
  );
}
